import React from "react";
import { Link } from "react-router-dom";

// Clean, minimal SVG logo for Agile Connexion
// variant: "dark" => for light backgrounds (default), "light" => for dark backgrounds
const Logo = ({ variant = "dark", showTagline = true }) => {
  const wordPrimary = variant === "light" ? "#ffffff" : "#15324f";
  const wordSecondary = variant === "light" ? "#9bc3e6" : "#3d6491";
  const tagColor = variant === "light" ? "rgba(255,255,255,0.7)" : "#6b7c8f";

  return (
    <Link to="/" className="flex items-center gap-3 group" aria-label="Agile Connexion">
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        className="shrink-0 transition-transform duration-300 group-hover:scale-105"
      >
        <circle cx="15" cy="15" r="7" stroke="#2f80c4" strokeWidth="2.5" />
        <circle cx="31" cy="31" r="7" fill="#15324f" />
        <line x1="19.5" y1="19.5" x2="26.5" y2="26.5" stroke="#3d6491" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="31" cy="31" r="2.5" fill="#9bc3e6" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="text-[20px] font-bold tracking-[0.12em]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          <span style={{ color: wordPrimary }}>AGILE</span>{" "}
          <span style={{ color: wordSecondary }}>CONNEXION</span>
        </span>
        {showTagline && (
          <span
            className="text-[9px] tracking-[0.22em] mt-1 font-medium"
            style={{ color: tagColor, fontFamily: "'Montserrat', sans-serif" }}
          >
            GOUVERNANCE TI · AGILITÉ · PERFORMANCE
          </span>
        )}
      </div>
    </Link>
  );
};

export default Logo;
